// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class MapPropertiesResource extends Resource {
    basePath: string = 'services/providers/map_props';

    objectPath: string = 'services/providers/map_props/{ident}/';
}
